import request from '@/lib/request';

const api = {};

// 登录或注册
api.loginOrRegister = (reqData = {}, autoErrorTips = true) => request({
  url: 'v1/user/login_register',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 已注册账户绑定媒体
api.bindMedia = (reqData = {}, autoErrorTips = true) => request({
  url: 'v3/media/bind/indirect',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 服务器缓存媒体方传递的code码，用于回调媒体方接口，解析用户信息
api.cacheCode = (reqData = {}, autoErrorTips = true) => request({
  url: 'v1/cp/user/cache/code',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 注册中台账户+绑定媒体账户
api.registerAndBindAccount = (reqData = {}, autoErrorTips = true) => request({
  url: 'v3/media/register/nocertification',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 获取媒体信息
api.getMediaInfo = (reqData = {}, autoErrorTips = true) => request({
  url: 'v1/media/type/info',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 接受主账号的邀请
api.acceptMasterAccountInvite = (reqData = {}, autoErrorTips = true) => request({
  url: 'v3/cp/user/accept',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

export default api;
